import CircleInfo from './CircleInfo';

export default CircleInfo;
